function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { memo } from "react";
var SvgContentCopy = function SvgContentCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 1.33334H6.00016C4.5335 1.33334 3.3335 2.53334 3.3335 4V22.6667H6.00016V4H22.0002V1.33334ZM26.0002 6.66667H11.3335C9.86683 6.66667 8.66683 7.86667 8.66683 9.33334V28C8.66683 29.4667 9.86683 30.6667 11.3335 30.6667H26.0002C27.4668 30.6667 28.6668 29.4667 28.6668 28V9.33334C28.6668 7.86667 27.4668 6.66667 26.0002 6.66667ZM26.0002 28H11.3335V9.33334H26.0002V28Z",
    fill: "url(#paint0_linear_7878_34306)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7878_34306",
    x1: 3.3335,
    y1: 4.94788,
    x2: 31.2349,
    y2: 23.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFEBA5"
    }, "stopColor", "color(display-p3 1.0000 0.9216 0.6471)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#FFC700",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFC700"
    }, "stopColor", "color(display-p3 1.0000 0.7804 0.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFE27B"
    }, "stopColor", "color(display-p3 1.0000 0.8863 0.4824)"), "stopOpacity", 1)
  }))));
};
var Memo = /*#__PURE__*/memo(SvgContentCopy);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/content_copy.f8ef8787d4e4eb0bca01a334085926a1.svg";